import Routers from "./layouts/Routers";
import { Route } from "react-router-dom";
import Home from "./pages/home";
import { createWeb3Modal, defaultConfig } from "@web3modal/ethers5/react";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const projectId = "8ec0c378d24abbf93366b8f866a41d6c";
const queryClient = new QueryClient();

// 2. Set chains
const X1Testnet = {
  chainId: 196,
  name: "X Layer Mainnet",
  currency: "OKB",
  explorerUrl: "https://www.oklink.com/xlayer",
  rpcUrl: "https://rpc.xlayer.tech",
};
const metadata = {
  name: "XLAYER-KATANAINU",
  description: "XLAYER-KATANAINU",
  url: "https://xlayer.katanainu.com",
  icons: ["https://avatars.mywebsite.com/"],
};
const ethersConfig = defaultConfig({
  /*Required*/
  metadata,

  /*Optional*/
  enableEIP6963: true, // true by default
  enableInjected: true, // true by default
  enableCoinbase: true, // true by default
  rpcUrl: "https://rpc.xlayer.tech", // used for the Coinbase SDK
  defaultChainId: 196, // used for the Coinbase SDK
});
// 3. Create modal

createWeb3Modal({
  ethersConfig,
  chains: [X1Testnet],
  defaultChain: X1Testnet,
  projectId,
});

/*  =========== pages ======== */
/*  ===========End pages ======== */
function App() {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <ToastContainer />
        <Routers>
          <Route path="/" element={<Home />} />
        </Routers>
      </QueryClientProvider>
    </>
  );
}

export default App;
